// https://vuex.vuejs.org/en/getters.html

export default {
  //
  user(state) {
    return state.user;
  },
  config(state) {
    return state.vendors.find(v => v.id === state.vid) || {};
  },
};
